import React from 'react';

export const globalStateContextDefaults = {
	menuOpened: true,
	menuToggleProgress: 0,
	menuSelectedAnchor: '*',
};

export const GlobalStateContext = React.createContext(
	globalStateContextDefaults
);

export default GlobalStateContext;
